let BASE_URL = '' 
if (process.env.NODE_ENV === 'development') {
  BASE_URL = 'https://ws4.pacsonline.cn' // 开发
  // BASE_URL = 'http://192.168.110.139:805' // 桂岩
}  else if (process.env.NODE_ENV === 'production') {
  BASE_URL = 'https://ws4.pacsonline.cn' // 环境
}
//导出
export default BASE_URL